/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FollowButton_favoritesConnection = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly serviceId: string | null;
        } | null;
    } | null> | null;
    readonly " $refType": "FollowButton_favoritesConnection";
};
export type FollowButton_favoritesConnection$data = FollowButton_favoritesConnection;
export type FollowButton_favoritesConnection$key = {
    readonly " $data"?: FollowButton_favoritesConnection$data;
    readonly " $fragmentRefs": FragmentRefs<"FollowButton_favoritesConnection">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "FollowButton_favoritesConnection",
  "type": "favoritesConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "favoritesEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Favorite",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'd5daf1a913559ba64d69d9e096c60c23';
export default node;
